import styled from 'styled-components';

export const Content = styled.div``;

export const Table = styled.table`
  margin: 0 0 10px;
  font-size: 14px;
  th,
  td {
    padding: 0 5px 5px 0;
  }
  th {
    text-align: left;
    color: #fff;
    font-weight: normal;
    font-size: 13px;
    padding-bottom: 10px;
    vertical-align: middle;
  }
  button {
    margin: 0 0 0 1.6em;
    line-height: 1;
  }
  td > span {
    display: block;
    position: relative;
    color: #000;
  }
`;
